// @ts-check
// src/stores/invoices.js — Faza E.2 — Invoices state in Nanostores

import { atom } from 'nanostores';

// FU-6 (21.09.2026): dawny `$invoicesFilters` był martwy — filtry listy faktur żyją WYŁĄCZNIE w
// `window.__sbState.invoicesFilters` (legacy-state.ts), a dwa źródła stanu tylko myliły.

/** Aktualna strona w paginacji */
export const $invoicesPage = atom(1);

/** Czy panel z filtrami widoczny */
export const $invoicesPanelVisible = atom(true);

/** Currently viewing document id (drawer open) */
export const $viewingDocumentId = atom(/** @type {number | null} */ (null));

/** Currently editing document id (form open). null = create new */
export const $editingDocumentId = atom(/** @type {number | null} */ (null));

/** Context: 'invoices' | 'order' | 'orders-detail' itp. — gdzie drawer został otwarty */
export const $invContext = atom('invoices');

/** Aktywna zakładka na stronie /invoices: 'documents' | 'series' | 'settings' itp. */
export const $invoicesTab = atom('documents');

if (typeof window !== 'undefined') {
  window.__sbStores = Object.assign(window.__sbStores || {}, {
    $invoicesPage,
    $invoicesPanelVisible,
    $viewingDocumentId,
    $editingDocumentId,
    $invContext,
    $invoicesTab,
  });
}
